import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { OVContext } from '../../../utils/OVContext';
import { SCROLL } from '../../../config/constants';
import css from './index.module.scss';
import outerWidth from '../../../utils/dom/outerWidth';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TechnicalDetails = function TechnicalDetails(_ref) {
  var productTitle = _ref.productTitle,
      technicalDetails = _ref.technicalDetails;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var _useContext = useContext(OVContext),
      mobileMedium = _useContext.mobileMedium;

  var firstRef = useRef(null);
  var rootRef = useRef(null);
  var total = technicalDetails.length;

  var goTo = function goTo(idx) {
    var current = rootRef.current;
    setIndex(idx);
    current.scrollTo({
      left: outerWidth(firstRef.current) * idx - 36
    });
  }; // The scrolling logic


  useEffect(function () {
    var current = rootRef.current; // Timer, used to detect whether horizontal scrolling is over

    var interval = null;

    var onScroll = function onScroll() {
      clearTimeout(interval); // Renew timer

      interval = setTimeout(function () {
        var newIndex = Math.floor(current.scrollLeft / Math.floor(outerWidth(firstRef.current)));

        if (newIndex !== index && newIndex <= total - 1) {
          setIndex(newIndex);
        }
      }, 50);
    }; // Scrolling event start


    current.addEventListener(SCROLL, onScroll);
    return function () {
      clearTimeout(interval);
      current.removeEventListener(SCROLL, onScroll);
    };
  }, [firstRef, index, setIndex, total]);
  var title = 'Technical Details';

  var nav = /*#__PURE__*/_jsx("div", {
    className: css.indicators,
    children: technicalDetails.map(function (_ref2, idx) {
      var id = _ref2.id,
          image = _ref2.image;
      return /*#__PURE__*/_jsx("button", {
        "aria-label": "Click to display the ".concat(image.alt, " technical detail image"),
        className: cc([css.indicator, _defineProperty({}, css.on, index === idx)]),
        onClick: function onClick() {
          return goTo(idx);
        },
        type: "button",
        children: "\xA0"
      }, "indicator-".concat(id));
    })
  });

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: css.titleMobile,
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: css.panels,
      children: [/*#__PURE__*/_jsxs("div", {
        className: css.details,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.title,
          children: title
        }), technicalDetails.map(function (_ref4, idx) {
          var id = _ref4.id,
              image = _ref4.image;
          var className = cc([css.detail, _defineProperty({}, css.on, index === idx)]);

          var kids = /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("div", {
              className: css.detailTitle,
              children: image.alt
            }), /*#__PURE__*/_jsx("div", {
              className: css.detailCopy,
              children: image.description
            })]
          });

          if (mobileMedium) {
            return /*#__PURE__*/_jsx("div", {
              className: className,
              children: kids
            }, "detail-".concat(id));
          }

          return /*#__PURE__*/_jsx("button", {
            "aria-label": "Click or hover to display the ".concat(image.alt, " technical detail image"),
            className: className,
            onFocus: function onFocus() {
              return goTo(idx);
            },
            onMouseOver: function onMouseOver() {
              return goTo(idx);
            },
            type: "button",
            children: kids
          }, "detail-".concat(id));
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: css.images,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.imageList,
          ref: rootRef,
          role: "list",
          children: technicalDetails.map(function (_ref6, idx) {
            var id = _ref6.id,
                image = _ref6.image;
            return /*#__PURE__*/_jsx("div", {
              "aria-hidden": index === idx ? undefined : true,
              className: cc([css.image, _defineProperty({}, css.on, index === idx)]),
              ref: idx === 0 ? firstRef : null,
              role: "listitem",
              children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
                alt: "A detail image of ".concat(productTitle, " with ").concat(image.alt),
                wrap: false
              }))
            }, "image-".concat(id));
          })
        }), technicalDetails.length > 1 && /*#__PURE__*/_jsx("div", {
          className: css.nav,
          children: nav
        })]
      }), technicalDetails.length > 1 && /*#__PURE__*/_jsx("div", {
        className: css.navMobile,
        children: nav
      })]
    })]
  });
};

TechnicalDetails.propTypes = {
  productTitle: PropTypes.string,
  technicalDetails: PropTypes.arrayOf(PropTypes.shape({}))
};
export default TechnicalDetails;